<div
    class="d-flex flex-column w-100 pb-2"
    [class.align-items-start]="_collapsed"
>
    <cmps-container class="cmps-scorecard-widget--cmps-container">
        <cmps-container-stripe
            [color]="
                this.scorecardTrendChartRootDefinition?.scorecardTrendChart
                    ?.containerColour
            "
        ></cmps-container-stripe>
        <cmps-container-header [separator]="false">
            <h3 class="mb-0">
                {{
                    scorecardTrendChartRootDefinition?.scorecardTrendChart.name
                }}
            </h3>
            <cmps-icon
                [svgIcon]="_collapsed ? 'scorecard:trend' : null"
                class="svg-export ml-2 cmps-scorecard-widget--sc-trend-icon"
            ></cmps-icon>
            <div
                class="sc-periodtype-container"
                *ngIf="
                    state?.selectedTrendChart &&
                    !_collapsed &&
                    _hasDataToShow &&
                    !!scorecardHistoryData
                "
            >
                <span class="sc-periodtype-title">{{
                    _i18n._9293_PERIOD_TYPE | translate
                }}</span>
                <select
                    class="sc-select ml-3"
                    [ngModel]="selectedPeriodType"
                    (focus)="_onPeriodTypeFocus()"
                    (click)="$event.stopPropagation()"
                    (ngModelChange)="_onPeriodTypeChange($event)"
                >
                    <option
                        *ngFor="let i of periodTypes"
                        [value]="i.periodTypeId"
                    >
                        {{ i.periodTypeName }}
                    </option>
                </select>
            </div>
            <div
                class="sc-trend-view"
                *ngIf="
                    state?.selectedTrendChart &&
                    !_collapsed &&
                    _hasDataToShow &&
                    !!scorecardHistoryData &&
                    state?.selectedTrendChart?.scorecardTrendChartData
                        ?.showTrendViewOptions
                "
            >
                <button
                    class="cmps-icon-button--no-bg sc-trend-view-btn"
                    [class.sc-trend-view-active]="
                        state?.selectedView === _View.COMPACT
                    "
                    cmpsIconButton
                    (click)="_onTrendViewClick($event, _View.COMPACT)"
                >
                    <cmps-icon svgIcon="scorecard:compact"></cmps-icon>
                    <span cmpsIconButtonLabel>{{
                        _i18n._9299_COMPACT_VIEW | translate
                    }}</span>
                </button>
                <button
                    class="cmps-icon-button--no-bg sc-trend-view-btn"
                    [class.sc-trend-view-active]="
                        state?.selectedView === _View.WIDE
                    "
                    cmpsIconButton
                    (click)="_onTrendViewClick($event, _View.WIDE)"
                >
                    <cmps-icon svgIcon="scorecard:wide"></cmps-icon>
                    <span cmpsIconButtonLabel>{{
                        _i18n._9300_WIDE_VIEW | translate
                    }}</span>
                </button>
            </div>
        </cmps-container-header>
        <cmps-container-content [hidden]="_collapsed">
            <cmps-wait-status
                [srStatus]="'Loading'"
                *ngIf="_isLoadingData"
            ></cmps-wait-status>
            <div
                *ngIf="
                    !_isLoadingData &&
                    !(_hasDataToShow && !!scorecardHistoryData)
                "
            >
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>
            <div
                class="w-100"
                *ngIf="
                    !_isLoadingData && _hasDataToShow && !!scorecardHistoryData
                "
            >
                <sc-supergroup-filter
                    [superGroups]="state?.selectedTrendChart?.supergroupsFilter"
                    (superGroupsChange)="_onSuperGroupsFilterChange($event)"
                >
                </sc-supergroup-filter>
                <div
                    class="sc-no-data-available"
                    *ngIf="!_hasFilteredDataToShow"
                >
                    {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
                </div>
                <ng-chart-vertical-bar-line
                    *ngIf="_hasFilteredDataToShow"
                    [options]="_verticalBarLineOptions"
                    [data]="
                        state?.selectedTrendChart?.scorecardTrendChartData
                            ?.verticalBarLineData
                    "
                    (rendered)="_onRendered()"
                    (barMouseMove)="
                        _positionTooltip($event.event, _tooltipElement)
                    "
                    (barMouseOver)="_onVerticalBarHover($event)"
                    (barMouseOut)="_onVerticalBarOut()"
                    (barSelect)="_onVerticalBarSelected($event.d)"
                    (rankAxisMouseOver)="_onRankAxisMouseOver($event)"
                    (rankAxisMouseMove)="
                        _positionTooltip($event.event, _rankTooltipElement, 'r')
                    "
                    (rankAxisMouseOut)="_onRankAxisMouseOut()"
                >
                    <ng-template ngChartVerticalBarLineNavLeft>
                        <button
                            class="cmps-icon-button--no-bg"
                            cmpsIconButton
                            (click)="_onNavigateClick($event, -0.5)"
                        >
                            <cmps-icon svgIcon="scorecard:left"></cmps-icon>
                        </button>
                    </ng-template>
                    <ng-template ngChartVerticalBarLineNavRight>
                        <button
                            class="cmps-icon-button--no-bg"
                            cmpsIconButton
                            (click)="_onNavigateClick($event, 0.5)"
                        >
                            <cmps-icon svgIcon="scorecard:right"></cmps-icon>
                        </button>
                    </ng-template>
                </ng-chart-vertical-bar-line>
                <div class="sc-filter-rank-scorecard-status">
                    <sc-rank-and-scorecard-published-status-filter
                        [ranksFilter]="state?.selectedTrendChart?.ranksFilter"
                        [scorecardPublishedStatusFilter]="
                            state?.selectedTrendChart?.publishStatusFilter
                        "
                        (ranksFilterChange)="_onRankFilterChange($event)"
                        (scorecardPublishedStatusFilterChange)="
                            _onScorecardPublishStatusFilterChange($event)
                        "
                    >
                    </sc-rank-and-scorecard-published-status-filter>
                </div>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>
<button
    class="cmps-icon-button--sm cmps-icon-button--no-bg sc-trend-header--toggle-expand"
    cmpsIconButton
    [cmpsTooltipTrigger]="
        _collapsed
            ? (_i18n._9977_EXPAND | translate)
            : (_i18n._9978_COLLAPSE | translate)
    "
    trigger="hover"
    (click)="_onToggleExpandClick()"
>
    <cmps-icon
        [class.sc-toggle-expand--c2e]="!_collapsed"
        [class.sc-toggle-expand--e2c]="_collapsed"
        svgIcon="chevron-down"
    ></cmps-icon>
</button>

<div
    id="sc-tooltip"
    class="sc-tooltip"
>
    <p>
        <span>{{ _i18n._773_PERIOD | translate }}</span>
        <span class="float-right">
            <span class="sc-tooltip-space"
                >{{ _i18n._9250_FROM | translate }}:
                {{ _tooltipData?.startDate | cmpsDate: 'MMM-dd-yyyy' }}</span
            >
            <span
                >{{ _i18n._9253_TO | translate }}:
                {{ _tooltipData?.endDate | cmpsDate: 'MMM-dd-yyyy' }}</span
            >
        </span>
    </p>
    <p>
        <span>{{ _i18n._67_SUPERGROUP | translate }}</span>
        <span class="float-right">{{ _tooltipData.superGroup }}</span>
    </p>
    <p>
        <span>{{ _i18n._962_OVERALL_SCORE | translate }}</span>
        <span class="float-right">{{
            _tooltipData.score | number: '1.0-2'
        }}</span>
    </p>
    <p *ngFor="let rank of _tooltipData?.ranks">
        <span
            >{{ _i18n._9251_MY | translate }} {{ rank.rankTypeName }}
            {{ _i18n._777_RANK | translate }}</span
        >
        <span class="float-right"
            >{{ rank.myRank || '- ' }}/{{ rank.maxRank || ' -' }}</span
        >
    </p>
    <p *ngIf="_tooltipData.published != null">
        <span>{{ _i18n._127_STATUS | translate }}</span>
        <span class="float-right">
            {{
                (_tooltipData?.published
                    ? _i18n._9113_PUBLISHED
                    : _i18n._9114_UNPUBLISHED
                ) | translate
            }}
        </span>
    </p>
</div>

<div
    id="sc-rank-tooltip"
    class="sc-tooltip-rank"
>
    <span>{{ _rankTooltipData }}</span>
</div>
